import { useQuery } from '@tanstack/react-query';
import { strapiGetCustomer } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useCustomerDetailQuery(jwt: string | null, documentId: string | null) {
  return useQuery({
    queryKey: queryKeys.customerDetail(jwt, documentId),
    queryFn: () => strapiGetCustomer(jwt!, documentId!),
    enabled: Boolean(jwt && documentId),
  });
}
